<template>
  <div class="products-management-page ma-4 ">
        <div class="d-flex justify-end mb-4">
      <v-btn class="btn-get-code rounded-lg px-4" @click="isShowAddStore = true">
        <v-icon left>mdi-store-plus</v-icon>
        افزودن فروشگاه آنلاین
      </v-btn>
    </div>
        <AddOnlineStore
      v-model="isShowAddStore"
      @refresh="(e)=>{rerender=e}"
    />


    <custom-tabs
      v-model="activeTab"
      :tab-items="tabs"
      class="mx-2 my-4 "
      grow
    >
      <template #staticItems>
        <!-- تب اول: محصولات فعال -->
        <v-tab-item>
          <OnlineStoresTab />
        </v-tab-item>
        <v-tab-item>
          <OnlineStoresDisConnectedTab />
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import AddOnlineStore from "./AddOnlineStore.vue";
import OnlineStoresDisConnectedTab from "./OnlineStoresDisConnectedTab.vue";
import OnlineStoresTab from "./OnlineStoresTab.vue";

export default {
  name: "OnlineStores",
  components: {
    OnlineStoresDisConnectedTab,
    OnlineStoresTab,
    AddOnlineStore
  },
  data() {
    return {
      rerender:false,
      isShowAddStore: false,
      activeTab: 0,
      tabs: [
        {
          text: "لیست فروشگاه متصل",
          icon: "link-lock",
        },
        {
          text: "لیست فروشگاه منفصل",
          icon: "link-off",
        },
      
         
      ],
    };
  },
//   mounted() { this.fetchStores(); },
  methods:{
        onPricingSaved() { this.isShowPricingModal = false; },
    //         async fetchStores() {
    //   this.loading = true;
    //   try {
    //     const res = await this.$api.get(`v1/store`, { params: this.tableParams });
    //     if (res.data?.status) {
    //       this.tableData = res.data.data;
    //     }
    //   } catch (err) { this.$toast?.error?.("خطا در دریافت لیست فروشگاه‌ها"); }
    //   finally { this.loading = false; }
    // },

  }
};
</script>
